module.exports = __webpack_public_path__ + "img/status-support.9b3621cf.png";